import accusations from 'reducers/accusations';
import blocks from 'reducers/blocks';
import conversation from 'reducers/conversation';
import conversation_history from 'reducers/conversation_history';
import environments from 'reducers/environments';
import evaluations from 'reducers/evaluations';
import favorites from 'reducers/favorites';
import issues from 'reducers/issues';
import locations from 'reducers/locations';
import modal from 'reducers/modal';
import notification from 'reducers/notification';
import organizations from 'reducers/organizations';
import pickup_tags from 'reducers/pickup_tags';
import reservable from './reservable';
import report_modal from 'reducers/report_modal';
import special_features from 'reducers/special_features';
import students from 'reducers/students';
import teachers from 'reducers/teachers';
import tencentSdkInfo from 'reducers/tencentSdkInfo';
import tutorial from 'reducers/tutorial';
import { combineReducers } from 'redux';
import video_chat from 'reducers/video_chat';
import support_comment from 'reducers/support_comment';
import tagFilter from 'reducers/tags';
import billing from 'reducers/billing';
const rootReducer = combineReducers({
    accusations,
    blocks,
    conversation,
    conversation_history,
    environments,
    evaluations,
    favorites,
    issues,
    locations,
    modal,
    notification,
    organizations,
    pickup_tags,
    report_modal,
    reservable,
    special_features,
    students,
    teachers,
    tencentSdkInfo,
    tutorial,
    video_chat,
    support_comment,
    tagFilter,
    billing,
});
export default rootReducer;
